import Connector, { takeQuery } from '../../agent';
import types from './types';
import { entityType } from '../../constants';
import { generateJavaSearchDto } from '../../components/Filtering/QueryGenerators/JavaQueryBuilder';
import { getSearchQuery } from '../filter/selectors';
import { goToErrorPage } from '../../utils';
import { SHARE_DATA_VIEW } from '../../constants';

const InventoryDataView = {
  getDefaultDataView: params => {
    if (entityType.inventory === params.entityType) {
      return Connector.api.get(
        `/inventoryList/defaultDataview` +
          (params.id ? `/${params.id}` : ``) +
          (params.latestDataViewId ? `?latestDataViewId=${params.latestDataViewId}` : ``)
      );
    } else if (entityType.product === params.entityType) {
      return Connector.api.get(
        `/chemicalProductList/defaultDataview` +
          (params.latestDataViewId ? `?latestDataViewId=${params.latestDataViewId}` : ``)
      );
    } else if (entityType.productHist === params.entityType) {
      return Connector.api.get(
        `/chemicalProductHistList/defaultDataview` +
          (params.id ? `/${params.id}` : ``) +
          (params.latestDataViewId ? `?latestDataViewId=${params.latestDataViewId}` : ``)
      );
    } else if (entityType.inventoryHist === params.entityType) {
      return Connector.api.get(
        `/inventoryHistList/defaultDataview` +
          (params.id ? `/${params.id}` : ``) +
          (params.latestDataViewId ? `?latestDataViewId=${params.latestDataViewId}` : ``) +
          (params.isDeleted !== undefined
            ? (params.latestDataViewId ? `&` : `?`) + `isDeleted=${params.isDeleted}`
            : ``)
      );
    } else if (entityType.building === params.entityType) {
      return Connector.api.get(
        `/buildingSummaryList/defaultDataview` +
          (params.buildingNum ? `/${params.buildingNum}` : ``)
      );
    } else if (entityType.batchUpdate === params.entityType) {
      return Connector.api.get(`/inventoryBatchUpdateList/defaultDataview`);
    } else if (entityType.activity === params.entityType) {
      return Connector.api.get(`/activityList/defaultFilteredList`)
    }
  },
  getDataViewList: entityTypeParam => {
    return Connector.api.get(`/dataview/getAllDataViews/${entityTypeParam.entityType}`);
  },
  getFavoriteDataViewList: () => {
    return Connector.api.get(`/dataview/getAllFavoriteDataViews`);
  },
  createNewDataView: params => {
    return Connector.api.post(
      `/dataview/createNewDataView?dataViewName=${params.dataViewName}` +
        (params.entityType ? `&entityType=${params.entityType}` : ''),
      generateJavaSearchDto(params)
    );
  },
  deleteDataView: params =>
    Connector.api.delete(
      `/dataview/${params.id}` + (params.entityType ? `?entityType=${params.entityType}` : '')
    ),
  lockUnlockDataView: params => {
    return Connector.api.post(
      `/dataview/lockUnlockDataView` +
        (params.id ? `?dataViewId=${params.id}` : ``) +
        (params.entityType ? `&entityType=${params.entityType}` : '')
    );
  },
  favoriteUnfavoriteDataView: params => {
    return Connector.api.post(
      `/dataview/favoriteUnfavoriteDataView` +
        (params.id ? `?dataViewId=${params.id}` : ``) +
        (params.entityType ? `&entityType=${params.entityType}` : '')
    );
  },
  getShareUrlDataView: params => {
    return Connector.api.post(
      `/dataview/getShareUrl` +
        (params.dataViewId ? `?dataViewId=${params.dataViewId}` : ``) +
        (params.entityType ? `&entityType=${params.entityType}` : '') +
        (params.sharedDataViewName ? `&sharedDataViewName=${params.sharedDataViewName}` : ''),
      generateJavaSearchDto(params)
    );
  },

  shareDataView: params => {
    return Connector.api.post(
      `/dataview/shareDataView` +
        (params.sharedDataView ? `${SHARE_DATA_VIEW}${params.sharedDataView}` : ``) +
        (params.entityType ? `&entityType=${params.entityType}` : '') +
        (params.sharedDataViewName ? `&sharedDataViewName=${params.sharedDataViewName}` : '')
    );
  },
};

const dataViewSagas = [
  takeQuery(types.GET_DEFAULT_DATAVIEW, {
    api: InventoryDataView.getDefaultDataView,
    notifyFailure: [goToErrorPage],
  }),
  takeQuery(types.GET_DATAVIEW_LIST, InventoryDataView.getDataViewList),
  takeQuery(types.GET_FAVORITE_DATAVIEW_LIST, InventoryDataView.getFavoriteDataViewList),
  takeQuery(types.CREATE_NEW_DATAVIEW, {
    api: InventoryDataView.createNewDataView,
    select: getSearchQuery,
  }),
  takeQuery(types.DELETE_DATAVIEW, InventoryDataView.deleteDataView),
  takeQuery(types.LOCK_DATAVIEW, InventoryDataView.lockUnlockDataView),
  takeQuery(types.FAVORITE_DATAVIEW, InventoryDataView.favoriteUnfavoriteDataView),
  takeQuery(types.GET_SHARE_URL_DATAVIEW, {
    api: InventoryDataView.getShareUrlDataView,
    select: getSearchQuery,
  }),
  takeQuery(types.SHARE_DATAVIEW, InventoryDataView.shareDataView),
];

export default dataViewSagas;
